@if (formStatus | async; as state) {
  @if (state === actionState.READY) {
    <form [formGroup]="configForm" (keydown.enter)="$event.preventDefault()" id="configForm"
      >
      <h2 (click)="isCollapsed = !isCollapsed" class="p-20">
        {{'stations.form.connectionOpcua' | translate}}
        @if (f.name.value.length > 0) {
          : {{f.name.value}}
        }
        <i class="chevron icon-chevron-down icon-collapse" [class.d-none]="isCollapsed === false"></i>
        <i class="chevron icon-chevron-up icon-collapse" [class.d-none]="isCollapsed === true"></i>
      </h2>
      @if (!isCollapsed) {
        <div class="pb-20 px-20">
          <hr class="first-hr">
          <h3>{{'stations.form.technical_details' | translate}}</h3>
          <div class="field-group d-flex flex-wrap">
            <div class="col-3">
              <div class="form-group">
                <label for="name"
                class="required">{{'stations.form.label.connection_name' | translate}}</label>
                <input formControlName="name" type="text" class="form-control" id="name"
                  [placeholder]="'stations.form.placeholder.connection_name' | translate">
                @if (f.name.invalid && (f.name.dirty || f.name.touched)) {
                  <div class="alert alert-danger">
                    @if (f.name.errors.required) {
                      <div>
                        {{'error.is_required' | translate}}
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="form-group">
                <label for="active">{{'stations.form.label.connection_activate' | translate}}</label>
                <select formControlName="active" class="form-control" id="active">
                  @for (activateAction of activateActionList; track activateAction) {
                    <option [value]="activateAction"
                      class="text-capitalize">
                      {{'stations.connection_state.' + activateAction | translate }}
                    </option>
                  }
                </select>
              </div>
              @if (connectionState) {
                <div class="form-group">
                  <label>{{'stations.form.label.connection_state' | translate}}</label>
                  <div class="text-uppercase">
                    <i class="connection-state {{connectionState.toLowerCase()}}"></i>
                    {{'stations.connection_state.' + connectionState | translate}}
                  </div>
                </div>
              }
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="uri" class="required">{{'stations.form.label.connection_uri' | translate}}</label>
                <div class="prefix-url__ctn">
                  <input type="text" class="form-control prefix-url" [value]="prefixUrl" disabled>
                  <input formControlName="uri" type="text" class="form-control" id="uri">
                </div>
                @if (f.uri.invalid && (f.uri.dirty || f.uri.touched)) {
                  <div class="alert alert-danger">
                    @if (f.uri.errors.required) {
                      <div>
                        {{'error.is_required' | translate}}
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="form-group">
                <label for="node">{{'stations.form.label.connection_node' | translate}}</label>
                <input formControlName="node" type="text" class="form-control" id="node"
                  [placeholder]="'stations.form.placeholder.node_opcua' | translate">
              </div>
            </div>
            <div class="col-3">
              <div formGroupName="credentials">
                <div class="form-group">
                  <label for="login">{{'stations.form.label.login' | translate}}</label>
                  <input formControlName="login" type="text" class="form-control" id="login"
                    [placeholder]="'stations.form.placeholder.login' | translate">
                </div>
                <div class="form-group">
                  <label for="password">{{'stations.form.label.password' | translate}}</label>
                  <input  [appTogglePassword] formControlName="password" type="password" class="form-control" id="password"
                    [placeholder]="'stations.form.placeholder.password' | translate">
                </div>
              </div>
              <div formGroupName="security">
                <div class="form-group">
                  <label for="mode">{{'stations.form.label.security_mode' | translate}}</label>
                  <select formControlName="mode" class="form-control" id="mode">
                    @for (securityMode of securityModeList; track securityMode) {
                      <option [value]="securityMode"
                        class="text-capitalize">
                        {{securityMode}}
                      </option>
                    }
                  </select>
                </div>
                <div class="form-group">
                  <label for="policy">{{'stations.form.label.security_policy' | translate}}</label>
                  <select formControlName="policy" class="form-control" id="policy">
                    @for (securityPolicy of securityPolicyList; track securityPolicy) {
                      <option [value]="securityPolicy"
                        class="text-capitalize">
                        {{securityPolicy}}
                      </option>
                    }
                  </select>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="acquisitionLostDelay" #tooltip="matTooltip" matTooltipPosition="below"
                  matTooltipClass="tooltip"
                  [matTooltip]="'stations.form.label.acquisition_lost_delay_detail' | translate">{{'stations.form.label.acquisition_lost_delay' | translate}}
                  <i class="fas fa-info-circle ml-5"></i>
                </label>
                <input formControlName="acquisitionLostDelay" type="text" class="form-control"
                  id="acquisitionLostDelay"
                  [placeholder]="'stations.form.placeholder.acquisition_lost_delay' | translate">
              </div>
              <!-- DELETE NOT IMPLEMENTED -->
              <!-- <a *ngIf="!creationView && config.uid" href="javascript:void(0);" class="delete-config text--danger" [ngClass]="{'disabled': !isEditting}" (click)="onDeleteConfig()">
              {{'action.delete_config' | translate }}
            </a> -->
          </div>
        </div>
        <div class="btn__ctn text-right">
          @if (!isEditting) {
            <button [appReadWrite]="FEATURE.SITE_MANAGEMENT" class="btn btn--primary" type="button" (click)="toggleEdition()"
              >
              {{'action.edit' | translate}}
            </button>
          } @else {
            <button class="btn btn--primary mr-20" type="button" (click)="onSubmit()">
              {{'action.submit' | translate}}
            </button>
            @if (!creationView && !config.newConnection) {
              <button class="btn btn--outline-grey-color" type="button" (click)="toggleEdition(true)"
                >
                {{'action.cancel' | translate}}
              </button>
            }
          }
        </div>
        <hr>
          @if (opcuaUid && !creationView) {
            <div class="mt-20 mb-10">
              <h3>{{'stations.form.label.configuration_table' | translate}}</h3>
              <div class="wrap-file-actions">
                <app-file-download (userWantsDownloadEvent)="onUserWantsDownloadEvent($event)" [backendResponse]="backendResponseDownloadedFile"></app-file-download>
                <app-file-upload [appReadWrite]="FEATURE.SITE_MANAGEMENT" (userWantsUploadEvent)="onUserWantsUploadEvent($event)" [backendResponse]="backendResponseUploadedFile"></app-file-upload>
              </div>
            </div>
          }
        </div>
      }
    </form>
  }
}